import leadTableActions from './leadList';
import leadProfileActions from './leadData';
import leadSearchActions from './leadSearch';

export default {
  ...leadTableActions,
  ...leadProfileActions,
  ...leadSearchActions
};
